import {apiClient} from "../apiClient";
import QueryHelpers from "../../components/helpers/QueryHelpers";

const getAllEvents = (args) => {
    const params = {
        page: args.page,
        pageSize: args.pageSize ?? 10,
        title: args.search,
        createdFrom: args.createdFrom ?? '2025-01-01',
        createdTo: args.createdTo ?? '2030-01-01',
        sort: args.sort
    }
    if(args.dateFrom) {
        params.dateFrom = args.dateFrom;
    }
    if(args.dateTo) {
        params.dateTo = args.dateTo;
    }

    const query = QueryHelpers.buildQueryString(params);
    return apiClient.get(`/events?${query}`);
}

const getEvent = (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    return apiClient.get(`/events/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

const getEventParticipants = (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    return apiClient.get(`/events/${id}/participants`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

const deleteEventParticipant = (eventId, id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    return apiClient.delete(`/events/${eventId}/participants/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

const create = (event) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const form = {
        title: event.title,
        parentEventTitle: event.parentTitle || null,
        address: event.address,
        date: event.date,
        startTime: event.startTime,
        endTime: event.endTime,
        maxParticipants: parseInt(event.maxParticipants),
        description: event.description || null,
        coverImage: event.coverImage,
        originalCoverImageName: event.coverImageName
    };

    return apiClient.post('/events', form, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

const update = (event) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const form = {
        id: event.id,
        title: event.title,
        parentEventTitle: event.parentTitle || null,
        address: event.address,
        date: event.date,
        startTime: event.startTime,
        endTime: event.endTime,
        maxParticipants: parseInt(event.maxParticipants),
        description: event.description || null,
        coverImage: event.coverImage,
        originalCoverImageName: event.coverImageName
    };

    return apiClient.put(`/events/${event.id}`, form, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

const deleteEvent = (id) => {
    const user = JSON.parse(localStorage.getItem("user"));

    return apiClient.delete(`/events/${id}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

const uploadCoverImage = (file) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const formData = new FormData();
    formData.append("file", file);

    return apiClient.post('/events/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${user.token}`
        }
    });
}

export default {
    getAllEvents,
    getEvent,
    getEventParticipants,
    deleteEventParticipant,
    create,
    update,
    deleteEvent,
    uploadCoverImage
}
